module.exports = __webpack_public_path__ + "img/unknown-1.361c261d.webp";